package one.healthium.log_weight.ui.internal

internal data class LogWeightUiState(
    val loading: Boolean = false,
    val latestWeightLog: WeightUiModel? = null,
    val initialWeight: Float = 0f,
    val isMetric: Boolean = false,
)